// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-preview-modal.has-doc .modal-container {
  max-width: 940px !important;
  height: 100%;
}
.lsn-preview-modal.active.is-busy,
.lsn-preview-modal.active.is-busy .modal-body {
  overflow: hidden !important;
}
.lsn-preview-modal iframe,
.lsn-preview-modal embed {
  width: 100%;
  height: 100%;
  border: var(--main-border-width) solid var(--main-border-color);
}
.lsn-preview-modal .modal-body {
  text-align: center;
  display: grid;
  height: 100%;
  min-height: 5rem;
  grid-template-rows: 1fr auto;
  padding: 0;
}
.lsn-preview-modal .modal-body p {
  padding-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/PreviewModal/PreviewModal.less"],"names":[],"mappings":"AAGE;EACE,2BAAA;EACA,YAAA;AAFJ;AAKE;;EAEE,2BAAA;AAHJ;AALA;;EAaI,WAAA;EACA,YAAA;EACA,+DAAA;AAJJ;AAXA;EAmBI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,UAAA;AALJ;AAnBA;EA2BM,iBAAA;AALN","sourcesContent":["@import (once) '../../../styles/variables';\n\n.lsn-preview-modal {\n  &.has-doc .modal-container {\n    max-width: 940px !important;\n    height: 100%;\n  }\n\n  &.active.is-busy,\n  &.active.is-busy .modal-body {\n    overflow: hidden !important;\n  }\n\n  iframe,\n  embed {\n    width: 100%;\n    height: 100%;\n    border: var(--main-border-width) solid var(--main-border-color);\n  }\n\n  .modal-body {\n    text-align: center;\n    display: grid;\n    height: 100%;\n    min-height: 5rem;\n    grid-template-rows: 1fr auto;\n    padding: 0;\n\n    p {\n      padding-top: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
